import type { QueryFunctionContext } from '@tanstack/react-query';
import { InvitationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { invitationsKeys } from 'app/queries/invitations/invitationsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof invitationsKeys.detail>>;

export const createFetchInvitationQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ invitationId }], signal }: TParams) =>
    call(() => cancelOnSignal(InvitationsService.getInvitation({ invitationId }), signal));
